import { Accessor, Setter, createContext, createSignal, useContext } from "solid-js";
import { createPublisher } from './publisher';
import { requireContext } from "./util";

export function getFocusKeyFromRequest() {
    const params = new URLSearchParams(window.location.search);

    return window.ST?.FocusKey
        ?? params.get('FOCUS_KEY')
        ?? '';
}

const [subscribeToFocusKey, publishFocusKey] = createPublisher<string>();

(window as any).__stPublishFocusKey = publishFocusKey;

// These methods shouldn't be used directly. They exist only for component fetch requests and the st-focus control
// If you need to do anything focus related, use the st-focus api.
export class FocusContextBase {
    focusKey: Accessor<string>;
    setFocusKey: Setter<string>;

    constructor() {
        [this.focusKey, this.setFocusKey] = createSignal(getFocusKeyFromRequest());
        subscribeToFocusKey(newKey => this.setFocusKey(newKey));
    }
}

export const FocusContextJsx = createContext<FocusContextBase>();
export function useFocusContext() { return useContext(FocusContextJsx); }
export function requireFocusContext() {
    return requireContext(FocusContextJsx);
}

